import React from "react";
import { Box } from "@mui/material";
import BuyerCompletionList from "../../BuyerCompletionList";

import LineChart from "../../LineChart";
import StatCard from "../../StatCard";
import {
  ContractAnalyticsResponse,
  ContractOverviewResponse,
} from "../../../../types/contracts";
import styles from "./performanceDashboard.module.scss";

interface PerformanceDashboardProps {
  analyticsData: ContractAnalyticsResponse;
  overviewData: ContractOverviewResponse;
}

const PerformanceDashboard: React.FC<PerformanceDashboardProps> = ({
  analyticsData,
  overviewData,
}) => {
  const completionData = analyticsData.completionByBuyer || [];

  const bestPerformer =
    completionData.length > 0
      ? completionData.reduce((best, current) =>
          current.completionPct > best.completionPct ? current : best,
        )
      : null;

  const expiringInTwoWeeks =
    overviewData.secondaryCards?.expiringInTwoWeeks || 0;

  const fastestCct = analyticsData.fastestCct;
  const fastestCctDays = fastestCct?.cctDays || 0;
  const fastestCctContract = fastestCct?.contractName || "N/A";

  return (
    <>
      <Box className={styles.fullWidthChart}>
        <BuyerCompletionList
          title="% Completion By Buyer"
          data={completionData}
          nameKey="buyerName"
          rateKey="completionPct"
          countKey="contractsCount"
        />
      </Box>

      <Box className={styles.chartsGrid}>
        <LineChart
          title="Avg CCT (Calendar Days)"
          data={analyticsData.avgCctByMonth || []}
          xAxisKey="month"
          dataKey="avgCctDays"
          lineColor="#5b6b9e"
          legendLabel="Average CCT"
          valueUnit="days"
        />
        <LineChart
          title="Avg CCT - Signed Contracts"
          data={[]}
          xAxisKey="month"
          dataKey="avgCctDays"
          lineColor="#00d2aa"
          legendLabel="Signed CCT"
          valueUnit="days"
        />
      </Box>

      <Box className={styles.statCardsGrid}>
        <StatCard
          type="performer"
          title="Best Performer"
          value={bestPerformer?.buyerName || "N/A"}
          subtitle={`${bestPerformer?.completionPct || 0}% completion rate`}
        />
        <StatCard
          type="fastest"
          title="Fastest CCT"
          value={`${fastestCctDays} Days`}
          subtitle={fastestCctContract}
        />
        <StatCard
          type="attention"
          title="Needs Attention"
          value={String(expiringInTwoWeeks)}
          subtitle="Expiring in 2 weeks"
        />
      </Box>
    </>
  );
};

export default PerformanceDashboard;
